import { api } from '@/lib/api';
import type {
  IApiResponse,
  IRegionsResponse,
  IFilterProductsResponse,
  IFilterTeamsResponse,
} from '@skystone/shared';

export const filterApi = {
  getRegions: async (): Promise<IRegionsResponse> => {
    const result = await api.get<IApiResponse<IRegionsResponse>>('/filters/regions');
    return result.data;
  },

  getProducts: async (region?: string): Promise<IFilterProductsResponse> => {
    const search = new URLSearchParams();
    if (region) search.set('region', region);
    const qs = search.toString();
    const result = await api.get<IApiResponse<IFilterProductsResponse>>(
      qs ? `/filters/products?${qs}` : '/filters/products',
    );
    return result.data;
  },

  getTeams: async (region?: string, productId?: string, includeArchived?: boolean): Promise<IFilterTeamsResponse> => {
    const search = new URLSearchParams();
    if (region) search.set('region', region);
    if (productId) search.set('productId', productId);
    // PRODOPSAI-621: omitted entirely when not opted in.
    if (includeArchived === true) search.set('includeArchived', 'true');
    const qs = search.toString();
    const result = await api.get<IApiResponse<IFilterTeamsResponse>>(
      qs ? `/filters/teams?${qs}` : '/filters/teams',
    );
    return result.data;
  },
};
